module.exports = filterXSS;